import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "settings-fixed-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "settings-fixed-header--title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "FTP Settings")
], -1)
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "ftp-wrapper with-fixed-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "p-top-8" }, " Some of our services have options to configure your jobs (such as number of months for an NCOA job). If a file is uploaded on this website, you can easily select these options via dropdowns. For jobs uploaded via FTP, you can specify those options below. Not all job types have options, so only those services which can be configured are listed below. ", -1)
const _hoisted_6 = { class: "ftp__blocks m-top-40" }
const _hoisted_7 = { class: "ftp__folder-settings m-right-32" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "m-bottom-24" }, "FTP Folders Settings", -1)
const _hoisted_9 = {
  key: 1,
  class: "ftp-loader"
}
const _hoisted_10 = { class: "ftp__credentials" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "m-bottom-24" }, "Your FTP Credentials", -1)
const _hoisted_12 = {
  key: 2,
  class: "ftp-loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FTPFolderSettings = _resolveComponent("FTPFolderSettings")!
  const _component_FTPCredentials = _resolveComponent("FTPCredentials")!
  const _component_FTPAccessIsClosed = _resolveComponent("FTPAccessIsClosed")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "btn fill t-t-u medium",
        disabled: !Object.keys(_ctx.editedOptions).length,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveChanges && _ctx.saveChanges(...args)))
      }, "Save changes", 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          (_ctx.options && _ctx.pricing)
            ? (_openBlock(), _createBlock(_component_FTPFolderSettings, {
                key: 0,
                options: _ctx.options,
                pricing: _ctx.pricing,
                onEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editedOptions = $event))
              }, null, 8, ["options", "pricing"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          (_ctx.credentials)
            ? (_openBlock(), _createBlock(_component_FTPCredentials, {
                key: 0,
                credentials: _ctx.credentials
              }, null, 8, ["credentials"]))
            : (!_ctx.credentials && !_ctx.loaderCredentials)
              ? (_openBlock(), _createBlock(_component_FTPAccessIsClosed, { key: 1 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_12))
        ])
      ])
    ])
  ], 64))
}